<!-- 发票详情 -->
<template>
  <div id class="business-content-main">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true"></breadcrumb>
    </div>
    <div class="invoiceMain">
      <div class="div-table-row invoice-title">您的发票申请分{{invoiceNum}}张发票开具，开具总额￥{{invoiceMoney}}</div>
      <div :key="index" v-for="(item,index) in invoiceList" class="invoice-item">
        <div class="div-table-row">
          <div
            class="div-table-cell"
            style="width: 100%"
          >发票{{index+1}}.发票号：{{item.InvoiceNum}}，发票金额：￥{{item.InvoiceMoney }}</div>
        </div>
        <div class="div-table-row">
          <div class="div-table-cell" style="width: 50%">
            发票性质：{{item.Property}}
            <a :href="item.Url" target="_blank" class="invoice-link">下载</a>
          </div>
          <div class="div-table-cell" style="width: 50%">发票状态：{{item.InvoiceStateName}}</div>
        </div>
        <div class="div-table-row">
          <div class="div-table-cell" style="width: 50%">发票类型：{{item.TypeName}}</div>
          <div class="div-table-cell" style="width: 50%">发票抬头：{{item.Title}}</div>
        </div>
        <div class="div-table-row">
          <div class="div-table-cell" style="width: 50%">申请时间：{{item.ApplyTime}}</div>
          <div class="div-table-cell" style="width: 50%">发票编号：{{item.InvoiceCode}}</div>
        </div>
        <div class="div-table-row">
          <div class="div-table-cell" style="width: 100%">备注：{{item.Remark}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    breadcrumb
  },
  data() {
    return {
      invoiceMoney: 0,
      invoiceNum: 0,
      invoiceList: [],
      searchData: {
        OrderId: ""
      }
    };
  },
  mounted() {
    this.searchData.OrderId = this.$route.query.OrderId;
    this.getTableData();
  },
  methods: {
    getTableData() {
      this.$util
        .axiosGet({
          url: "/api/EntpInfoManagement/GetEntpOrderInvoiceList",
          data: this.searchData
        })
        .then(res => {
          let data = res.data;
          if (!data) data = {};
          this.invoiceList = data.Detail;
          this.invoiceNum = data.TotalCount;
          this.invoiceMoney = data.TotalAmount;
        })
        .catch(() => {});
    },
    back() {
      window.history.back(-1);
    }
  }
};
</script>
<style lang="less" scoped>
.invoice-item {
  margin-bottom: 20px;
}
.bread-nav {
  align-items: center;
  justify-content: space-between;
  align-items: center;
}
.div-table-row {
  line-height: 40px;
  .div-table-cell {
    padding-left: 10px;
  }
}
.invoice-title {
  border: 1px solid @border2Color;
  background: @border3Color;
  padding-left: 10px;
}
.invoice-link {
  display: inline-block;
  width: 30px;
}
</style>
